import { createComponent } from '@lit-labs/react';
import React from 'react';

export class BaseIconDS extends HTMLElement {
  icon?: string;
  big?: string;
  constructor() {
    super();
  }
}

export const BaseIcon = createComponent(React, 'base-icon', BaseIconDS, {});
